export default __webpack_public_path__ + "static/page-header-dont-1-7ff2da96b5b488e36d950231db5c3325.png";